import translate from '../plugins/translate'

const state = {
    filters: localStorage.getItem('orderFilters') ? 
        JSON.parse(localStorage.getItem('orderFilters')) : 
        {
            ID:{label:'ID', title:translate('Nº', 'AtendimentosTable'), values:[]},
            ACAO_COM_USUARIO_ID: {label:'ACAO_COM_USUARIO_ID', title:translate('Ação Com', 'AtendimentosTable'), values:[]},
            CLIENTE_ID: {label:'CLIENTE_ID', title:translate('Cliente', 'AtendimentosTable'), values:[]},
            DATA_INICIO: {label:'DATA_INICIO', title:translate('Dt. Ini.', 'AtendimentosTable'), values:[]},
            SOLICITANTE_ID: {label:'SOLICITANTE_ID', title:translate('Solicitante', 'AtendimentosTable'), values:[]},
            RESPONSAVEL_ID: {label:'RESPONSAVEL_ID', title:translate('Responsável', 'AtendimentosTable'), values:[]},
            SITUACAO_ID: {label:'SITUACAO_ID', title:translate('Situação', 'AtendimentosTable'), values:[]}
        },
    filterOptions: localStorage.getItem('orderFilterOptions') ? 
        JSON.parse(localStorage.getItem('orderFilterOptions')) :
        {
            clients: [],
            responsibles: [],
            orders: [],
            orderRequesters: [],
            orderResponsibles: [],
            situations: []
        } ,
    filterValues: localStorage.getItem('orderFilterValues') ? JSON.parse(localStorage.getItem('orderFilterValues')) : []
}

const getters = {
    filters(state) {
        return state.filters
    },
    filterOptions(state) {
        return state.filterOptions
    },
    filterValues(state) {
        return state.filterValues
    }
}

const actions = {
    setFilters({commit}, filters){
        commit('FILTERS', filters)
    },
    setFilterOptions({commit}, filterOptions){
        commit('FILTER_OPTIONS', filterOptions)
    },
    setFilterValues({commit}, filterValues){
        commit('FILTER_VALUES', filterValues)
    }
}

const mutations = {
    FILTERS(state, filters) {
        state.filters = filters
        localStorage.setItem('orderFilters', JSON.stringify(filters))
    },
    FILTER_OPTIONS(state, filterOptions){
        state.filterOptions = filterOptions
        localStorage.setItem('orderFilterOptions', JSON.stringify(filterOptions))
    },
    FILTER_VALUES(state, filterValues){
        state.filterValues = filterValues
        localStorage.setItem('orderFilterValues', JSON.stringify(filterValues)) 
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
